import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoLotesDispositivosComponent } from './listado-lotes-dispositivos/listado-lotes-dispositivos.component';

const routes: Routes = [
  {
    path: '',
    component: ListadoLotesDispositivosComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LotesDispositivosRoutingModule {}
